import type { ReactNode } from 'react'

import { Footer } from './Footer'
import { Logo } from '../Icons/Logo'

interface SplitPageLayoutProps {
  children: ReactNode
  image: string
}

export function SplitPageLayout({ children, image }: SplitPageLayoutProps) {
  return (
    <div className="flex min-h-full flex-1 flex-col xl:overflow-y-auto">
      <div className="flex flex-grow">
        <div className="flex flex-1 flex-col bg-surface overflow-y-auto justify-center">
          <div className="mx-auto w-full max-w-[32rem] my-12 md:my-0 px-4 sm:px-8 md:px-10">
            <header>
              <Logo />
            </header>
            {children}
          </div>
        </div>
        <div className="relative hidden w-0 flex-1 xl:block">
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="absolute inset-0 h-full w-full object-cover bg-fixed bg-center bg-cover bg-no-repeat"
          />
          <div className="absolute bg-black/10 w-full h-full" />
        </div>
      </div>
      <Footer className="z-10 xl:sticky bottom-0" centered={false} />
    </div>
  )
}

export default SplitPageLayout
